import axios from "axios";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { url } from "../link";
const Updatelaptop2025 = () => {
  let rx = 0;
  const { state } = useLocation();
  const nav = useNavigate();

  const [lid, setlid] = useState(state[rx++]);
  const [laptopname, setlaptopname] = useState(state[rx++]);
  const [addons, setaddons] = useState(state[rx++]);
  const [givendate, setgivendate] = useState(state[rx++]);
  const [deliverydate, setdeliverydate] = useState(state[rx++]);
  const [commiment, setcommiment] = useState(state[rx++]);
  const [pid, setpid] = useState(state[rx++]);
  const [receivedby, setreceivedby] = useState(state[rx++]);

  const submitdata = () => {
    const value = {
      lid,
      laptopname,
      addons,
      givendate,
      deliverydate,
      commiment,
      pid,
      receivedby,
    };
    axios.post(url + "updatelaptop", value).then(() => {
      nav("/viewlaptop");
    });
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-warning text-dark text-center">
          <h3 className="mb-0">Update Laptop Details</h3>
        </div>
        <div className="card-body p-4">
          <form>
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                value={lid}
                onChange={(e) => setlid(e.target.value)}
                placeholder="Enter lid"
                readOnly
              />
              <label htmlFor="lid">Laptop ID</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                value={laptopname}
                onChange={(e) => setlaptopname(e.target.value)}
                placeholder="Enter laptop name"
              />
              <label htmlFor="laptopname">Laptop Name</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                value={addons}
                onChange={(e) => setaddons(e.target.value)}
                placeholder="Enter addons"
              />
              <label htmlFor="addons">Add-ons</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="date"
                className="form-control"
                value={givendate}
                onChange={(e) => setgivendate(e.target.value)}
              />
              <label htmlFor="givendate">Given Date</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="datetime-local"
                className="form-control"
                value={deliverydate}
                onChange={(e) => setdeliverydate(e.target.value)}
              />
              <label htmlFor="deliverydate">Delivery Date & Time</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                value={commiment}
                onChange={(e) => setcommiment(e.target.value)}
                placeholder="Enter commitment"
              />
              <label htmlFor="commiment">Commitment</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                value={pid}
                onChange={(e) => setpid(e.target.value)}
                placeholder="Enter PID"
              />
              <label htmlFor="pid">PID</label>
            </div>

            <div className="form-floating mb-4">
              <input
                type="text"
                className="form-control"
                value={receivedby}
                onChange={(e) => setreceivedby(e.target.value)}
                placeholder="Enter received by"
              />
              <label htmlFor="receivedby">Received By</label>
            </div>

            <button
              type="button"
              className="btn btn-warning w-100 py-2 fw-bold"
              onClick={submitdata}
            >
              Update Laptop
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Updatelaptop2025;
